import styled from 'styled-components';
import { spacing, Caption } from 'ui/theme';

export const InlineEditCharacterCount = styled(Caption)`
  display: block;
  margin-top: ${spacing.eighth};
`;

export const InlineEditWrapper = styled.div`
  width: auto;
  height: auto;
  z-index: 999999;
`;

export const InlineEditInput = styled.textarea<{ placeholderStyle?: Record<string, any> }>`
  outline-style: dotted;
  outline-width: 1px;
  outline-color: transparent;
  overflow: auto;
  background: transparent;
  border: 0 solid transparent;
  resize: none;
  padding: 0;
  opacity: 1;

  ::placeholder {
    ${({ placeholderStyle = {} }) => placeholderStyle}
  }
`;
